import { VaultDetails } from '../store/vaults';
import { calculateVaultUSDBalance } from './calculateVaultUSDBalance';

export const sortByTVL = (vault0: VaultDetails, vault1: VaultDetails) => {
  if (vault0.tvl > vault1.tvl) return -1
  if (vault0.tvl < vault1.tvl) return 1
  return 0
}

export const sortByAPR = (vault0: VaultDetails, vault1: VaultDetails) => {
  if (vault0.apr > vault1.apr) return -1
  if (vault0.apr < vault1.apr) return 1
  return 0
}

export const sortByBalance = (vault0: VaultDetails, vault1: VaultDetails) => {
  const v0BalanceUSD = calculateVaultUSDBalance(vault0);
  const v1BalanceUSD = calculateVaultUSDBalance(vault1);
  if (v0BalanceUSD > v1BalanceUSD) return -1
  if (v0BalanceUSD < v1BalanceUSD) return 1
  return 0
}